'use client'

import {FC, useEffect} from 'react'

import {getCurrentParams} from '@/utils/browser/location'
import {saveCampaignsData} from '@/utils/tracking/helpers'

/**
 * Persists campaign query params (utm_*, gclid, …) to localStorage.
 *
 * Always ran from an effect, so it reads `window.location` directly rather than subscribing to
 * search params — which keeps it usable from the shared shell, above the static/dynamic split.
 */
export const CampaignTracker: FC = () => {
  useEffect(() => {
    saveCampaignsData(getCurrentParams())
  })

  return null
}
